class LqdPfListHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.relayout = liquidDebounce(this.reLayout.bind(this), 150);

    this.initCustomAnimation();
    this.initMasonry();
    this.initCarousel();
    this.initResponsiveBg();

  }

  getDefaultSettings() {
    return {
      isotopeData: null,
      selectors: {
        customAnimationElement: '[data-custom-animations]',
        masonryElement: '[data-liquid-masonry]',
        carouselElement: '[data-lqd-flickity]',
        responsiveBgElement: '[data-responsive-bg]'
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $customAnimationElement: this.$element.find(selectors.customAnimationElement),
      $masonryElement: this.$element.find(selectors.masonryElement),
      $carouselElement: this.$element.find(selectors.carouselElement),
      $responsiveBgElement: this.$element.find(selectors.responsiveBgElement),
    }
  }

  initCustomAnimation() {

    this.elements.$customAnimationElement.liquidCustomAnimations();

  }

  initMasonry() {

    this.elements.$masonryElement.liquidMasonry({
      bypassCheck: true
    });

  }

  initCarousel() {

    this.elements.$carouselElement.liquidCarousel({
      bypassCheck: true
    });

  }

  initResponsiveBg() {

    this.elements.$responsiveBgElement.liquidResponsiveBG();
    
  }

  getIsotopeData() {

    const isotopeData = this.getSettings('isotopeData');

    if ( isotopeData ) {
      return isotopeData;
    }

    this.setSettings('isotopeData', this.elements.$masonryElement.data('plugin_liquidMasonry'));

    return this.getSettings('isotopeData');

  }

  onElementChange(propertyName) {
    
    switch (propertyName) {

      case 'columns_gap':
      case 'bottom_gap':
        this.relayout();

    }
    
  }

  reLayout() {

    const isotopeData = this.getIsotopeData();

    if ( ! isotopeData ) {
      return
    }

    isotopeData.isoData.layout();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleCustomAnimationDestroy();

  }

  handleCustomAnimationDestroy() {

    if ( ! this.elements.$customAnimationElement.length ) return;

    const customAnimationData = this.elements.$customAnimationElement.data('plugin_liquidCustomAnimations');

    if ( customAnimationData ) {
      customAnimationData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdPfListHandler, { $element } );
};